import flatpickr from '@nodeModules/flatpickr';

// we need to import all languages as they are used in locale: window.entrioLang - it wont work if language is not imported here
import { Croatian } from "@nodeModules/flatpickr/dist/l10n/hr.js";
import { Slovenian } from "@nodeModules/flatpickr/dist/l10n/sl.js";
import { Italian } from "@nodeModules/flatpickr/dist/l10n/it.js";
import { Bosnian } from "@nodeModules/flatpickr/dist/l10n/bs.js";
import { German } from "@nodeModules/flatpickr/dist/l10n/de.js";
import { english } from "@nodeModules/flatpickr/dist/l10n/default.js";
import dayjs from '@nodeModules/dayjs';

export const initPageJs = () => {
	if (window.searchTerm) {
		document.querySelector('.search__input').value = window.searchTerm;
	}

	document.querySelectorAll('.pills__action').forEach(el => {
		if (window.location.href == el.href && !el.classList.contains('pills__action--is-featured')) {
			el.classList.add('pills__action--is-active');
		}
	});

	const $form = document.querySelector('.search__form');
	const $filterActions = document.querySelectorAll('.js-filter');
    const $filterLists = document.querySelectorAll('.js-filter-list');
    const $filterListItems = document.querySelectorAll('.js-filter-list-item');
	const $clearFiltersAction = document.querySelector('.js-clear-filters');

	if ($clearFiltersAction) {
		$clearFiltersAction.addEventListener('click', event => {
			const url = `${window.location.origin}${window.location.pathname}?s=`;
			const searchInput = $form.querySelector('input[name="s"]');

			if (searchInput.value) {
				window.location = `${url}${searchInput.value}`;
			} else {
				window.location = url;
			}
		});
	}

	const params = new URLSearchParams(window.location.href);
	const $dateFilterEl = document.querySelector('.js-filter-list-item-custom-date');
	let defaultDates;

	if (params.get('time')) {
		if (dayjs(params.get('time')).isValid()) {
			defaultDates = dayjs(params.get('time')).format('YYYY-MM-DD');
		} else {
			const paramsSplit = params.get('time').split('/');

			if (
				dayjs(paramsSplit[0]).isValid() &&
				dayjs(paramsSplit[1]).isValid()
			) {
				defaultDates = [dayjs(paramsSplit[0]).format('YYYY-MM-DD'), dayjs(paramsSplit[1]).format('YYYY-MM-DD')];
			}
		}
	}

	flatpickr($dateFilterEl, {
		mode: 'range',
		defaultDate: defaultDates ? defaultDates : null,
		locale: window.entrioLang,
	    onChange: function(selectedDates, dateStr, instance) {
	        if (selectedDates.length >= 2) {
		        const startDate = dayjs(selectedDates[0]).format('YYYY-MM-DD');
		        const endDate = dayjs(selectedDates[1]).format('YYYY-MM-DD');

		        const difference = dayjs(endDate).diff(dayjs(startDate), 'day');

		        $filterLists.forEach((list) => {
		    		if (list.classList.contains('is-shown')) {
		    			list.classList.remove('is-shown');
		    		}
		    	});

		        const datesToFilter = difference !== 0 ? `${startDate}/${endDate}` : startDate;
		    	const hiddenInput = $form.querySelector('input[name="time"]');

		    	if (hiddenInput) {
		    		hiddenInput.value = datesToFilter;
		    	} else {
			    	const newInput = document.createElement('input');
					newInput.setAttribute('type', 'hidden');
					newInput.setAttribute('name', 'time');
					newInput.setAttribute('value', datesToFilter);

					$form.appendChild(newInput);
		    	}

		    	$form.submit();
	        }
	    },
	});

    if ($filterActions.length && $filterLists.length) {
    	$filterActions.forEach((action) => {
    		action.addEventListener('click', event => {
				event.stopPropagation();

				if (event.target.nextElementSibling.classList.contains('is-shown')) {
					event.target.setAttribute('aria-expanded', false);
					event.target.nextElementSibling.classList.remove('is-shown');
				} else {
					$filterActions.forEach((filterAction) => {
			    		if (filterAction.getAttribute('aria-expanded')) {
			    			filterAction.setAttribute('aria-expanded', false);
			    		}
			    	});
					$filterLists.forEach((list) => {
			    		if (list.classList.contains('is-shown')) {
			    			list.classList.remove('is-shown');
			    		}
			    	});

					event.target.setAttribute('aria-expanded', true);
					event.target.nextElementSibling.classList.add('is-shown');
				}
			});
    	});

    	$filterListItems.forEach((item) => {
    		if (item.classList.contains('filter__list-item--is-selected')) {
    			const filterAction = item.closest('.js-filter-list').previousElementSibling;
				filterAction.classList.add('filter__action--is-filled');
				filterAction.querySelector('.filter__action-text').innerText = item.innerText;

				const hiddenInput = $form.querySelector(`input[name='${filterAction.getAttribute('name')}']`);

				if (!hiddenInput) {
					const newInput = document.createElement('input');
					newInput.setAttribute('type', 'hidden');
					newInput.setAttribute('name', filterAction.getAttribute('name'));
					newInput.setAttribute('value', item.dataset.value);

					$form.appendChild(newInput);
				}
    		} else {
    			const filterAction = item.closest('.js-filter-list').previousElementSibling;
    			const hiddenInput = $form.querySelector(`input[name='${filterAction.getAttribute('name')}']`);
				const params = new URLSearchParams(window.location.href);

				if (!hiddenInput && params.get(filterAction.getAttribute('name'))) {
					const newInput = document.createElement('input');
					newInput.setAttribute('type', 'hidden');
					newInput.setAttribute('name', filterAction.getAttribute('name'));
					newInput.setAttribute('value', params.get(filterAction.getAttribute('name')));

					$form.appendChild(newInput);

					if (filterAction.getAttribute('name') === 'time') {
						if (dayjs(params.get(filterAction.getAttribute('name'))).isValid()) {
							filterAction.classList.add('filter__action--is-filled');
							filterAction.querySelector('.filter__action-text').innerText = dayjs(params.get(filterAction.getAttribute('name'))).format('DD.MM.YYYY');
						} else {
							const paramsSplit = params.get(filterAction.getAttribute('name')).split('/');

							if (
								dayjs(paramsSplit[0]).isValid() &&
								dayjs(paramsSplit[1]).isValid()
							) {
								filterAction.classList.add('filter__action--is-filled');
								filterAction.querySelector('.filter__action-text').innerText = `${dayjs(paramsSplit[0]).format('DD.MM.YYYY')}/${dayjs(paramsSplit[1]).format('DD.MM.YYYY')}`;
							}
						}
					}
				}
    		}

    		item.addEventListener('click', event => {
    			if (!event.target.classList.contains('js-filter-list-item-custom-date')) {
	    			if (!event.target.classList.contains('filter__list-item--is-selected')) {
	    				const filterAction = event.target.closest('.js-filter-list').previousElementSibling;
	    				filterAction.classList.add('filter__action--is-filled');
	    				filterAction.querySelector('.filter__action-text').innerText = event.target.innerText;

	    				const filterList = event.target.closest('.js-filter-list');

	    				const filterListItems = filterList.querySelectorAll('.js-filter-list-item');
	    				filterListItems.forEach((listItem) => {
				    		if (listItem.classList.contains('filter__list-item--is-selected')) {
				    			listItem.classList.remove('filter__list-item--is-selected');
				    		}
				    	});

				    	const hiddenInput = $form.querySelector(`input[name='${filterAction.getAttribute('name')}']`);

				    	if (hiddenInput) {
				    		hiddenInput.value = event.target.dataset.value;
				    	} else {
					    	const newInput = document.createElement('input');
							newInput.setAttribute('type', 'hidden');
							newInput.setAttribute('name', filterAction.getAttribute('name'));
							newInput.setAttribute('value', event.target.dataset.value);

							$form.appendChild(newInput);
				    	}

	    				event.target.classList.add('filter__list-item--is-selected');
	    				filterList.classList.remove('is-shown');
	    				$form.submit();
	    			}
	    		}
    		});
    	});
    }

    window.addEventListener('click', event => {
    	if ($filterLists.length) {
    		$filterLists.forEach((list) => {
	    		if (list.classList.contains('is-shown')) {
	    			if (
	    				event.target.closest('.js-filter-list.is-shown') ||
	    				event.target.closest('.flatpickr-calendar')
	    			) {
                		return;
            		} else {
	    				list.previousElementSibling.setAttribute('aria-expanded', false);
	    				list.classList.remove('is-shown');
            		}
	    		}
	    	})
    	}
	});

    if (document.querySelectorAll('.js-track-select-item').length) {
		document.querySelectorAll('.js-track-select-item').forEach(el => {
			if (window.searchTerm) {
				el.dataset.itemListName = window.searchTerm;
			}

	  		el.addEventListener('click', event => {
	  			event.preventDefault();
	  			window.track.trackSelectItem(event.currentTarget.dataset)
	  		})
		})

		window.track.trackViewItemList(document.querySelector('.js-track-view-item-list'));
    }
};
